import { checkhysteresis } from "../utils/checkhysteresis";
import { CompareHoverMsg } from "../utils/CompareHoverMsg";
import { kToolTipTimer } from "../constants";
import { QToolTip } from "./QToolTip";
import { hoverTimer } from "../utils/hoverTimer";
import { StartTime } from "../utils/StartTime";
import { Globals } from "./Globals";

export class QHoverMgr {
  constructor() {
    this.fWSMgr = null;
    this.fDisplayedMsg = null;
    this.fCurrentMsg = null;
    this.fTimer = null;
    this.fToolTip = null;
    this.fPriorX = null;
    this.fPriorY = null;

    this.fX = null;
    this.fY = null;
    this.fYTop = null;
  }

  Init(wsMgr) {
    this.fWSMgr = wsMgr;
    Globals._hoverMgr = this;
  }

  UpdateHoverMsg(hoverElement, hoverMsg, elementX, elementY, yTop, mouseX, mouseY) {
    this.fElement = hoverElement;
    this.fX = elementX;
    this.fY = elementY;
    this.fYTop = yTop;

    if (CompareHoverMsg(hoverMsg, this.fDisplayedMsg)) return;

    this.fCurrentMsg = hoverMsg;
    if (hoverMsg == null || hoverMsg.IsBlank()) this.ResetToolTip(false, null, null);
    else if (hoverMsg != null) {
      this.fPriorX = mouseX;
      this.fPriorY = mouseY;
      this.StartTimer();
    }
  }

  DisplayToolTip() {
    var newMsg = this.fCurrentMsg;
    this.ClearToolTip();

    var maxW = this.fWSMgr.GetCanvasWidth();
    var maxH = this.fWSMgr.GetCanvasHeight();

    this.fCurrentMsg = newMsg;
    this.fDisplayedMsg = newMsg;
    this.fToolTip = new QToolTip();
    this.fToolTip.fPanelResizeBehavior = this.fElement ? this.fElement.GetResizeBehavior() : null; // set pin behavior of element to match adjust tool tip pin positioning
    this.fToolTip.Init(this.fElement, newMsg, this.fX, this.fY, this.fYTop, maxW, maxH);
    this.fWSMgr.PushPanel(this.fToolTip);
    this.fWSMgr.RenderWS();
  }

  ClearToolTip() {
    if (this.fToolTip) {
      this.fWSMgr.RemovePanel(this.fToolTip);
      this.fToolTip = null;
      this.fCurrentMsg = null;
      this.fDisplayedMsg = null;
    }
  }

  ClearTimer() {
    if (this.fTimer) {
      clearTimeout(this.fTimer);
      this.TimerDone();
    }
  }

  ResetToolTip(mouseMoveEvent, x, y) {
    var doIt = true;
    if (mouseMoveEvent) {
      if (checkhysteresis(x, y, this.fPriorX, this.fPriorY)) doIt = false;

      this.fPriorX = x;
      this.fPriorY = y;
    } else {
      this.fPriorX = null;
      this.fPriorY = null;
    }

    if (doIt) {
      this.ClearTimer();
      this.ClearToolTip();
    }
  }

  TimerDone() {
    this.fTimer = null;
  }

  StartTimer() {
    //	console.log("Start Timer TT");
    this.ClearTimer();
    this.fTimer = setTimeout(function () {
      hoverTimer();
    }, kToolTipTimer);
  }
}
